<template>
  <layout>
    <template v-slot:header>
      <global-navigation></global-navigation>
    </template>

    <main
      v-if="hasPage"
      class="Shop"
    >
      <h1 class="wcag-hidden">Shop</h1>

      <paw v-if="isNotFound" />

      <div
        v-if="slideshowImages"
        class="slideshow"
      >
        <auto-flickity>
          <figure
            v-for="(image, i) in slideshowImages"
            :key="i"
          >
            <img
              :src="image.wares"
              class="slideshow-image"
              :style="`--imgRatio:${image.width / image.height};`"
            />
          </figure>
        </auto-flickity>

        <div
          class="slideshow-overlay"
          v-if="page.featuredoverlaysvg"
        >
          <img
            :src="page.featuredoverlaysvg"
            alt=""
            v-scroll-to="{ el: '#product-grid', offset: -100 }"
            draggable="false"
          />
          <img
            :src="page.featuredoverlaysvgmobile || page.featuredoverlaysvg"
            alt=""
            v-scroll-to="{ el: '#product-grid', offset: -100 }"
            draggable="false"
          />
        </div>
      </div>

      <!-- <figure v-if="page.featuredimage && page.featuredimage.wares" class="header" v-scroll-to="{el: '#product-grid', offset: -100}">
        <img :src="page.featuredimage.wares" alt="" />
        <figcaption v-if="page.featuredoverlaysvg">
          <img :src="page.featuredoverlaysvg" alt="" />
          <img :src="page.featuredoverlaysvgmobile || page.featuredoverlaysvg" alt="" />
        </figcaption>
      </figure> -->

      <!-- <section id="products">
        <rich-text :class="['content', { 'not-found': isNotFound }]" :content="page.text" />
      </section> -->

      <ProductGrid :collectionId="collectionId" />

      <div class="details-container">
        <div class="faq-container links">
          <rich-text
            class="center-headers"
            :content="page.details"
          />
          <VueFaqAccordion
            :items="page.faq"
            fontColor="#ffffff"
            activeColor="#ffffff"
            borderColor="#ffffff"
          />

          <h2
            class="uppercase"
            v-if="page.faqshipping"
          >
            Shipping
          </h2>
          <VueFaqAccordion
            v-if="page.faqshipping"
            :items="page.faqshipping"
            fontColor="#ffffff"
            activeColor="#ffffff"
            borderColor="#ffffff"
          />

          <h2
            class="uppercase"
            v-if="page.faqreturns"
          >
            Cancels/Returns
          </h2>
          <VueFaqAccordion
            v-if="page.faqreturns"
            :items="page.faqreturns"
            fontColor="#ffffff"
            activeColor="#ffffff"
            borderColor="#ffffff"
          />
        </div>

        <ul class="footer nord uppercase">
          <li
            v-for="link in page.footer"
            :key="link.url"
          >
            <vue-link :to="link.url">{{ link.title }}</vue-link>
          </li>
        </ul>
      </div>
    </main>

    <template v-slot:footer>
      <global-footer :border="true"></global-footer>
    </template>
  </layout>
</template>

<script>
// import Flickity from 'vue-flickity'
import VueFaqAccordion from 'vue-faq-accordion'
import MailchimpSubscribe from 'vue-mailchimp-subscribe'
import PageMixin from '@/mixins/PageMixin'
import AutoFlickity from '@/components/AutoFlickity'
import RichText from '@/components/RichText'
import Paw from '@/components/Paw'
import ProductGrid from '@/components/ProductGrid'

export default {
  name: 'Page',
  mixins: [PageMixin],
  components: { AutoFlickity, RichText, Paw, VueFaqAccordion, MailchimpSubscribe, ProductGrid },
  computed: {
    collectionId() {
      const site = this.$store.state.content['/*'] || {}
      const page = this.page || {}

      if (site && Object.keys(site).length > 0) {
        return site.collectionId
      } else if (page && Object.keys(page).length > 0) {
        return page.collectionId
      } else {
        return null
      }
    },
    mailchimpurl() {
      return this.site.mailchimpurl
    },
    mailchimpid() {
      return this.site.mailchimpid
    },
    mailchimplist() {
      return this.site.mailchimplist
    },
    showNewsletter() {
      return this.mailchimpurl && this.mailchimpid && this.mailchimplist
    },
    slideshowImages() {
      if (this.page && this.page.slideshow && this.page.slideshow.length) {
        if (this.page.slideshow.length <= 3) {
          return this.page.slideshow.concat(this.page.slideshow)
        } else {
          return this.page.slideshow
        }
      }
      return null
    },
  },
  methods: {
    formatPrice(price) {
      return price.replace('.00', '')
    },
  },
}
</script>

<style scoped>
.slideshow {
  margin: 0 2rem;
  width: calc(100% - 4rem);
  position: relative;
  border-radius: var(--br);
  overflow: hidden;
  z-index: 4;
}

.slideshow .slideshow-image {
  display: block;
  height: 85vh;
  width: calc(85vh * var(--imgRatio));
}

/*.slideshow-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5vw 25vw;
  pointer-events: none;
  z-index: 5;
}*/

.slideshow-overlay img {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 48vw;
  height: auto;
  z-index: 5;
  transform: translate(-50%, -50%);
  cursor: pointer;
}

.slideshow-overlay img:first-child {
  display: block;
}
.slideshow-overlay img:last-child {
  display: none;
}

@media (max-width: 1000px) {
  .slideshow figure {
    width: 100%;
  }

  .slideshow .slideshow-image {
    display: block;
    height: 67.5vh;
    width: 100%;
    object-fit: cover;
    object-position: center;
    /*width: calc(67.5vh * var(--imgRatio));*/
  }

  .slideshow-overlay img {
    width: 72vw;
  }

  .slideshow-overlay img:first-child {
    display: none;
  }
  .slideshow-overlay img:last-child {
    display: block;
  }
}

.header {
  border-radius: var(--br);
  position: relative;
  margin: 0 2rem;
  width: calc(100% - 4rem);
  max-height: calc(90vh - 12rem);
  overflow: hidden;
  cursor: pointer;
}

.header:before {
  content: '';
  display: block;
  padding-bottom: 56.25%;
}

.header > img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.header > figcaption {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5vw 25vw;
  pointer-events: none;
}

.header > figcaption > img:first-child {
  display: block;
}
.header > figcaption > img:last-child {
  display: none;
}

@media (max-width: 1000px) {
  .header:before {
    padding-bottom: 103%;
  }

  .header > figcaption > img:first-child {
    display: none;
  }
  .header > figcaption > img:last-child {
    display: block;
  }
}

.product-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding-left: 2rem;
  padding-right: 2rem;
  grid-gap: 2rem 2rem;
  padding-top: 2rem;

  /*display: flex;
  justify-content: center;*/
}

/* .product-grid-item {
  border: 1px dashed #fff;
  border-radius: var(--br);
  padding: 3rem;
  text-align: center;
}

.product-grid-item.empty-item {
  padding-top: 6rem;
  padding-bottom: 6rem;
}

.product-grid-item figure {
  padding-top: 75%;
  position: relative;
  margin-bottom: 2rem;
}

.product-grid-item figure > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
} */

/* .newsletter-grid-item {
  border: 1px dashed #fff;
  border-radius: var(--br);
  padding: 6rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.newsletter-grid-item > * + * {
  margin-top: 3rem;
}

.newsletter-grid-item.wide {
  grid-column: 1 / -1;
  padding: 6rem 22%;
}

@media (max-width: 1000px) {
  .newsletter-grid-item.wide {
    padding: 6rem;
  }
} */

.mailchimp-form {
  width: 100%;
}

.compare-at-price {
  position: relative;
}

.compare-at-price::after {
  content: '';
  width: 100%;
  height: 2px;
  background: #fff;
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
}

.has-compare-at-price {
  color: #fa3b41;
}

.details-container {
  display: grid;
  /*grid-template-columns: 1fr 1fr;*/
  grid-template-columns: repeat(5, minmax(0, 1fr));
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 8rem;
  grid-gap: 8rem 2rem;
}

.details-container .faq-container {
  grid-column: span 3 / span 3;
  grid-column-start: 2;
}

.faq-container h2 {
  text-align: center;
  margin-bottom: 3.6rem;
}

.faq-container h2:not(:first-child) {
  margin-top: 4.8rem;
}

.faq-container >>> article {
  margin-bottom: 3.6rem;
  text-align: center;
  padding-left: 4.8rem;
  padding-right: 4.8rem;
}

@media (max-width: 1360px) {
  .details-container {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .details-container .faq-container {
    grid-column: span 5 / span 5;
    grid-column-start: 2;
  }
}

@media (max-width: 1000px) {
  .details-container {
    grid-template-columns: 1fr 1fr;
  }

  .details-container .faq-container {
    grid-column: 1 / -1;
  }

  .faq-container >>> article {
    padding-left: 0;
    padding-right: 0;
  }
}

.faq-container >>> .faq {
  padding-left: 0;
  padding-right: 0;
}

.faq-container >>> .faq-wrapper {
  max-width: none;
}

.faq-container >>> .accordion {
  border-top: 1px dashed #fff;
  border-bottom: 1px dashed #fff;
  border-left: none;
  border-right: none;
  border-radius: 0;
}

.faq-container >>> .accordion__title,
.faq-container >>> .accordion__value {
  padding-left: 2rem;
  padding-right: 2rem;
}

@media (max-width: 1000px) {
  .faq-container >>> .accordion__title,
  .faq-container >>> .accordion__value {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

.faq-container >>> .accordion__title-text {
  font: var(--nord);
  text-transform: uppercase;
  margin-right: 2rem;
}

.faq-container >>> .accordion__item {
  border-bottom: 1px dashed #fff;
}

.faq-container >>> .accordion__item:last-child {
  border-bottom: none;
}

.faq-container >>> .accordion__toggle-button::before,
.faq-container >>> .accordion__toggle-button::after {
  background: #fff;
}

.details {
  padding-left: 8%;
  padding-right: 8%;
}

.footer {
  grid-column: 1 / -1;
  padding-bottom: 3rem;
  text-align: center;
}

.footer li {
  display: inline-block;
}

.footer li:not(:last-child) {
  margin-right: 2rem;
}

/* >>> .reverse {
  display: inline-block;
  transform: scaleX(-1);
} */

.not-found {
  text-align: center;
  font: var(--nord);
  text-transform: uppercase;
}

.content {
  padding: 5rem 22%;
  text-align: center;
}

/* .mailchimp-form {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 3rem 1rem;
}

.mailchimp-form input[type='email'] {
  grid-column: span 3 / span 3;
}

.mailchimp-form button {
  grid-column: span 2 / span 2;
}

.mailchimp-form .message {
  grid-column: 1 / -1;
}

@media (max-width: 1000px) {
  .mailchimp-form input[type='email'],
  .mailchimp-form button {
    grid-column: 1 / -1;
  }
} */

@media (max-width: 1360px) {
  .content {
    padding: 5rem 20%;
  }
  .header > figcaption {
    padding: 5vw 15vw;
  }
}

@media (max-width: 1000px) {
  .content {
    padding: 5rem 2rem;
  }
  .product-grid,
  .details-container {
    grid-template-columns: 1fr;
  }
  .details {
    padding-left: 0;
    padding-right: 0;
  }
  .footer {
    text-align: center;
  }
}
</style>
